
import { apiAxios } from "./axios";

const ALQEMI_RE_RUN_MATCHING_URL = "/re-run-matching";
const ALQEMI_CREATE_CV_URL = "/create-cv";

class AlqemiService {
  async reRunMatching(
    cvPrompt: string,
    emailTemplate: string,
    emailPrompt: string,
    simpleInput: any
  ): Promise<any> {
    const payload = {
      cvPrompt,
      emailTemplate,
      emailPrompt,
      inputData: simpleInput,
    };

    return (
      await apiAxios.post<any>(ALQEMI_RE_RUN_MATCHING_URL, payload)
    ).data;
  }

  async createCv(simpleInput: any): Promise<any> {
    const payload = {
      inputData: simpleInput,
    };

    return (await apiAxios.post<any>(ALQEMI_CREATE_CV_URL, payload)).data;
  }

  async sendAlqemiEmail(payload: any): Promise<void> {
    return (await apiAxios.post<void>("/send-alqemi-email", payload)).data;
  }

  /**
   * Payload: { matchId, emailContent, cv, jobTitle, candidateName, manualEmailOverride? }
   * Note: 'recruiterEmail' is deprecated — backend reads recruiter_email from the Match record.
   */
  async sendRecruiterEmail(payload: {
    matchId: string;
    emailContent: string;
    cv: string;
    jobTitle: string;
    candidateName: string;
    manualEmailOverride?: string;
  }): Promise<void> {
    return (await apiAxios.post<void>("/send-recruiter-email", payload)).data;
  }

  async sendRejectionEmail(payload: any): Promise<void> {
    return (await apiAxios.post<void>("/send-rejection-email", payload)).data;
  }
}

const alqemiService = new AlqemiService();
export default alqemiService;
